import { useRef, FC, ReactNode, useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';
import style from './index.module.scss';

/** CommonSimpleBar Props */
export interface Props {
  /** children */
  children: ReactNode;
}

/**
 * SimpleBar共通パーツ
 * 親コンポーネントの大きさによってSimpleBarの高さが変動する。
 * デザインは下記からSCSSを修正
 * https://codesandbox.io/p/sandbox/simplebar-react-and-vertical-middle-align-2imbxy?file=%2Fsrc%2Fstyles.css%3A1%2C1-182%2C1
 */
export const CommonSimpleBar: FC<Props> = ({ children }) => {
  const parentSimpleBarRef = useRef<HTMLDivElement>(null);
  const [simpleBarHeight, setSimpleBarHeight] = useState(0);

  useEffect(() => {
    setSimpleBarHeight(parentSimpleBarRef.current?.clientHeight || 0);
  }, [children]);

  return (
    <div className={style.modalSimpleBar} ref={parentSimpleBarRef}>
      <SimpleBar
        autoHide={false}
        style={{
          height: simpleBarHeight,
        }}
      >
        {children}
      </SimpleBar>
    </div>
  );
};
